let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gaMCD")).then(() => parcelRequire('7QgOZ'));